<template>
  <span v-bind="linkProps(to)">
    <slot/>
  </span>
</template>

<script>
import { isExternal } from '@/assets/utils/JiachenPanUtil';

export default {
  props: {
    to: {
      type: String,
      required: true
    }
  },

  methods: {
    isExternalLink(routePath) {
      return isExternal(routePath)
    },

    linkProps(url) {
      if(this.isExternalLink(url)) {
        return {
          is: 'a',
          href: url,
          target: '_blank',
          rel: 'noopener'
        }
      }

      if(url.indexOf("ticket-vue") == -1) {
        return {
          is: 'a',
          href: url,
          rel: 'noopener'
        }
      }

      return {
        is: 'router-link',
        to: url
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/sidebar/MenuLink.vue